// extracted by mini-css-extract-plugin
export default {"PrivacyPolicy":"MyClimb_PrivacyPolicy__Rm8YD","PrivacyPolicyContent":"MyClimb_PrivacyPolicyContent__0-atf"};